import React from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { FileText } from "lucide-react";
import TfnDeclarationForm from "./TfnDeclarationForm";
import SuperChoiceForm from "./SuperChoiceForm";
import InductionChecklistForm from "./InductionChecklistForm";
import HealthDeclarationForm from "./HealthDeclarationForm";

// Maps the onboarding forms registry ids
// (backend/constants/onboardingForms.constants.js) to their page components.
// The New Starter Form has its own dedicated route/page and is not listed here.
// A `requestId` query param switches the page into HR preview mode: the form
// renders the hire's submission read-only.
const FORM_PAGES: Record<string, React.FC<{ previewRequestId?: string | null }>> = {
  "tfn-declaration": TfnDeclarationForm,
  "super-choice": SuperChoiceForm,
  "induction-checklist": InductionChecklistForm,
  "health-declaration": HealthDeclarationForm,
};

const OnboardingFormPage: React.FC = () => {
  const { formId } = useParams<{ formId: string }>();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const previewRequestId = searchParams.get("requestId");
  const FormComponent = formId ? FORM_PAGES[formId] : undefined;

  if (!FormComponent) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4">
        <div className="bg-white rounded-2xl border border-gray-200 p-8 text-center max-w-sm w-full">
          <FileText className="w-10 h-10 text-gray-300 mx-auto mb-3" />
          <h1 className="text-base font-semibold text-gray-900 mb-1">
            Form not available
          </h1>
          <p className="text-sm text-gray-500 mb-5">
            This form doesn't exist or hasn't been set up yet.
          </p>
          <button
            onClick={() => navigate("/my-onboarding")}
            className="w-full py-2.5 rounded-xl bg-slate-900 text-white text-sm font-medium hover:bg-slate-800 transition-colors"
          >
            Back to Portal
          </button>
        </div>
      </div>
    );
  }

  return <FormComponent previewRequestId={previewRequestId} />;
};

export default OnboardingFormPage;
